import React from 'react';

const UserSidebar = () => {
  return <div>User Sidebar Content</div>;
};

export default UserSidebar;